import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './assets/fonts/Connary-Fagen-Criteria-CF-Regular.ttf'
import './assets/fonts/Connary-Fagen-Criteria-CF-Bold-Oblique.ttf'

import { GlobalStateProvider } from "./GlobalStateProvider";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <GlobalStateProvider>
        <App />
    </GlobalStateProvider>
);
